import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSatelliteDish, faEyeSlash, faBell } from '@fortawesome/free-solid-svg-icons';

interface LiveViewToggleProps {
  realtimeMode: boolean;
  onToggle: () => void;
}

export const LiveViewToggle: React.FC<LiveViewToggleProps> = ({ realtimeMode, onToggle }) => (
  <div className="flex items-center gap-2 mt-2">
    <button
      onClick={onToggle}
      className={`relative flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
        realtimeMode
          ? 'bg-green-500/20 text-green-300 border border-green-400/30'
          : 'bg-white/10 text-white/70 border border-white/20'
      }`}
    >
      <FontAwesomeIcon
        icon={realtimeMode ? faSatelliteDish : faEyeSlash}
        className={`text-sm ${realtimeMode ? 'animate-pulse' : ''}`}
      />
      <span>{realtimeMode ? 'Live' : 'View'}</span>
      <div className={`w-8 h-4 rounded-full transition-all ${realtimeMode ? 'bg-green-400' : 'bg-gray-500'}`}>
        <div className={`w-3 h-3 mt-0.5 rounded-full bg-white transition-all ${realtimeMode ? 'translate-x-4' : 'translate-x-0.5'}`} />
      </div>
    </button>
  </div>
);

interface LiveModeBufferBadgeProps {
  count: number;
  onFlush: () => void;
  label?: string;
}

export const LiveModeBufferBadge: React.FC<LiveModeBufferBadgeProps> = ({
  count,
  onFlush,
  label = 'รายการใหม่',
}) => {
  if (count === 0) return null;
  return (
    <div className="flex justify-end mb-2">
      <button
        onClick={onFlush}
        className="flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-bold
                   bg-gradient-to-r from-red-500 to-red-600 text-white
                   hover:from-red-600 hover:to-red-700 transition-all animate-pulse
                   shadow-lg hover:shadow-red-500/25 hover:scale-105"
      >
        <FontAwesomeIcon icon={faBell} className="text-sm" />
        <span>{count}</span>
        <span>{label}</span>
        <span className="text-white/70 font-normal">(กดดู)</span>
      </button>
    </div>
  );
};
